import {useState} from "react";
import Grid from "@mui/material/Grid2";
import {Button, Paper, Table,TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme} from "@mui/material";
import {OptimizeDetailTable} from "../components/OptimizeDetailTable";
import {formatCurrency} from "../utils/formatters";

export const OptimizeContainer = () => {
    const theme = useTheme();
    const [showReviewPanel, setShowReviewPanel] = useState(false);
    const [showDetailTable, setShowDetailTable] = useState(false);

    const data = [
        {title: 'SKUs with stagnant costs', impact: 160000, status: 'Recommend'},
        {title: 'Orders below target margins', impact: 120000, status: 'Reviewed'},
        {title: 'Accounts stopped buying (churn)', impact: 110000, status: 'Activated'},
        {title: 'SKUs with stagnant prices', impact: 110000, status: 'Deferred'},
        {title: 'Rep discount benchmark', impact: 110000, status: 'Deferred'},
        {title: 'Accounts with stagnant prices', impact: 60000, status: 'Recommend'},
        {title: 'Products below target margin', impact: 60000, status: 'Recommend'},
        {title: 'Discount exceptions', impact: 50000, status: 'Recommend'},
        {title: 'Unprofitable accounts', impact: 40000, status: 'Recommend'},
        {title: 'Price harmony', impact: 40000, status: 'Reviewed'},
        {title: 'Unprofitable SKUs', impact: 40000, status: 'Activated'},
        {title: 'Unprofitable Orders', impact: 20000, status: 'Reviewed'},
        {title: 'Over-discounting', impact: 20000, status: 'Recommend'},
        {title: 'Price harmony - SKUs out of alignment', impact: 20000, status: 'Activated'},
        {title: 'Underpriced products', impact: 20000, status: 'Deferred'},
        {title: 'Price discrepancies', impact: 20000, status: 'Deferred'},
        {title: 'Price outliers', impact: 10000, status: 'Deferred'}
    ];
    const detailData = [
        {id: 1, product_sku: 'BK-M68B-38', product_name: 'Mountain-200 Black, 38', customer_count: '107', net_price: '1365.62', unit_vcogs: '-860.34', unit_variable_margin: '505.28', variable_margin_percent: '0.37', variable_margin: '604819', rec_price_adjustment: '0.037', new_price: '1416.15', margin_impact: '60482', action: 'Accept'},
        {id: 2, product_sku: 'BK-R79Y-48', product_name: 'Road-350-W Yellow, 48', customer_count: '97', net_price: '992.99', unit_vcogs: '-670.27', unit_variable_margin: '322.72', variable_margin_percent: '0.325', variable_margin: '448583', rec_price_adjustment: '0.086', new_price: '1078.39', margin_impact: '118702', action: 'Accept'},
        {id: 3, product_sku: 'BK-M68B-42', product_name: 'Mountain-200 Black, 42', customer_count: '101', net_price: '1367.58', unit_vcogs: '-793.2', unit_variable_margin: '574.38', variable_margin_percent: '0.42', variable_margin: '539921', rec_price_adjustment: '0.025', new_price: '1401.77', margin_impact: '32138', action: 'Accept'},
        {id: 4, product_sku: 'BK-T79U-60', product_name: 'Touring-1000 Blue, 60', customer_count: '96', net_price: '1408.82', unit_vcogs: '-901.64', unit_variable_margin: '507.18', variable_margin_percent: '0.36', variable_margin: '493481', rec_price_adjustment: '0.042', new_price: '1467.99', margin_impact: '57573', action: ''},
        {id: 5, product_sku: 'BK-M68S-38', product_name: 'Mountain-200 Silver, 38', customer_count: '70', net_price: '1385.63', unit_vcogs: '-859.09', unit_variable_margin: '526.54', variable_margin_percent: '0.38', variable_margin: '449138', rec_price_adjustment: '0.056', new_price: '1463.23', margin_impact: '66189', action: ''},
        {id: 6, product_sku: 'BK-R79Y-40', product_name: 'Road-350-W Yellow, 40', customer_count: '99', net_price: '1006.3', unit_vcogs: '-820.13', unit_variable_margin: '186.17', variable_margin_percent: '0.185', variable_margin: '229170', rec_price_adjustment: '0.126', new_price: '1133.09', margin_impact: '156083', action: ''},
        {id: 7, product_sku: 'BK-T79U-46', product_name: 'Touring-1000 Blue,  46', customer_count: '94', net_price: '1412.09', unit_vcogs: '-931.98', unit_variable_margin: '480.11', variable_margin_percent: '0.34', variable_margin: '396091', rec_price_adjustment: '0.099', new_price: '1552.17', margin_impact: '115565', action: 'Deferred'},
        {id: 8, product_sku: 'BK-T79Y-60', product_name: 'Touring-1000 Yellow, 60', customer_count: '96', net_price: '1215.98', unit_vcogs: '-778.23', unit_variable_margin: '437.75', variable_margin_percent: '0.36', variable_margin: '426371', rec_price_adjustment: '0.044', new_price: '1269.48', margin_impact: '52112', action: 'Deferred'},
        {id: 9, product_sku: 'BK-M68S-42', product_name: 'Mountain-200 Silver, 42', customer_count: '66', net_price: '1384.45', unit_vcogs: '-802.98', unit_variable_margin: '581.47', variable_margin_percent: '0.42', variable_margin: '422146', rec_price_adjustment: '0.035', new_price: '1432.91', margin_impact: '35179', action: 'Deferred'},
        {id: 10, product_sku: 'BK-M68B-46', product_name: 'Mountain-200 Black, 46', customer_count: '69', net_price: '1373.69', unit_vcogs: '-741.79', unit_variable_margin: '631.9', variable_margin_percent: '0.46', variable_margin: '458126', rec_price_adjustment: '0.035', new_price: '1421.77', margin_impact: '34857', action: 'Deferred'},
        {id: 11, product_sku: 'BK-M68S-46', product_name: 'Mountain-200 Silver, 46', customer_count: '66', net_price: '1388.24', unit_vcogs: '-749.65', unit_variable_margin: '638.59', variable_margin_percent: '0.46', variable_margin: '448929', rec_price_adjustment: '0.022', new_price: '1418.78', margin_impact: '21471', action: 'Deferred'},
        {id: 12, product_sku: 'BK-T79Y-46', product_name: 'Touring-1000 Yellow, 46', customer_count: '92', net_price: '1220.06', unit_vcogs: '-829.64', unit_variable_margin: '390.42', variable_margin_percent: '0.32', variable_margin: '325219', rec_price_adjustment: '0.06', new_price: '1293.26', margin_impact: '60979', action: ''}
    ];

    const buttonColorMap = {
        'Recommend': theme.palette.button.blue,
        'Activated': theme.palette.button.green,
        'Reviewed': theme.palette.button.lightblue,
        'Deferred': theme.palette.button.gray,
    }

    const headerBaseStyle = {
        border: '1px solid rgba(224, 224, 224, 1)',
        borderRight: 'none',
        position: 'sticky',
        top: 0,
        zIndex: 0
    };

    const ReviewPanel = () => {
        return (
            <Paper style={{...theme.palette.contentPanel, width: 700, marginTop: 30, padding: 20}}>
                <Typography variant="h6" gutterBottom>
                    Recommendation Review
                </Typography>
                <Typography variant="h7" gutterBottom>
                    Opportunity: Increase prices on products below target margin
                </Typography>
                <Grid container justifySelf="left" spacing={2} sx={{marginTop: 2}}>
                    <Grid size={6}>
                        <Paper style={{width: 320, backgroundColor: '#323D7230', padding: 20}}>
                            <Typography variant="body1">
                                Summary:
                            </Typography>
                            <Typography variant="body2" style={{marginTop: 10}}>
                                # Impacted SKUs: 24 <br/>
                                # Impacted accounts: 107 <br/>
                                Average increase: <span style={{color: theme.palette.indicator.green}}><b>6.7%</b></span> <br/>
                                Estimated margin recovery: <span style={{color: theme.palette.indicator.green}}><b>$60K</b></span> <br/>
                                Confidence level: <span style={{color: theme.palette.indicator.green}}><b>High</b></span> <br/>
                                Risk: <span style={{color: theme.palette.indicator.orange}}><b>Medium</b></span> <br/>
                                Effective timing: 60 days <br/>
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid size={6}>
                        <Paper style={{width: 320, backgroundColor: '#323D7230', padding: 20}}>
                            <Typography variant="body1">
                                Root Cause:
                            </Typography>
                            <Typography variant="body2" style={{marginTop: 10}}>
                                Costs increased faster than prices
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid size={12}>
                        <Button sx={{padding: 0}} onClick={() => setShowDetailTable(true)}>Show Details</Button>
                    </Grid>
                </Grid>
            </Paper>
        );
    };

    const Row = ({idx, row}) => {
        const buttonColor = buttonColorMap[row.status];
        return (
            <TableRow key={idx} hover>
                <TableCell>{row.title}</TableCell>
                <TableCell align="right">{formatCurrency(row.impact, true, true)}</TableCell>
                <TableCell align="center">
                    <Button sx={{paddingTop: 0, paddingBottom: 0, backgroundColor: buttonColor}} onClick={() => setShowReviewPanel(true)}>{row.status}</Button>
                </TableCell>
            </TableRow>
        );
    };

    return (
        <div style={{marginLeft: 20}}>
            <Grid container justifySelf="left" spacing={1}>
                <Grid size={6} justifySelf="left" justifyItems="center">
                    <Paper style={{...theme.palette.contentPanel, width: 700, margin: 30, padding: 20}}>
                        <Typography variant="h6" gutterBottom>
                            Opportunity Inbox
                        </Typography>
                        <TableContainer>
                            <Table stickyHeader size="small" sx={{tableLayout: 'fixed'}}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" sx={{...headerBaseStyle, width: '250px', backgroundColor: '#323D7230'}}>
                                            Opportunity Title
                                        </TableCell>
                                        <TableCell align="right" sx={{...headerBaseStyle, width: '150px', backgroundColor: '#323D7230'}}>
                                            Est. Margin Impact
                                        </TableCell>
                                        <TableCell align="center" sx={{...headerBaseStyle, width: '180px', backgroundColor: '#323D7230'}}>
                                            Opportunity Status
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((row, idx) => {
                                        return <Row idx={idx} row={row}/>
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>
                <Grid size={6} justifyItems="left">
                    {showReviewPanel &&
                        <ReviewPanel></ReviewPanel>
                    }
                    {!showReviewPanel && <div style={{width: 800}}/>}
                </Grid>
                <Grid size={12} justifyItems="left">
                    {showDetailTable &&
                        <OptimizeDetailTable theme={theme} data={detailData} loading={false}/>
                    }
                </Grid>
            </Grid>
        </div>
    );
};